// 迁移自mobile项目 /src/common/interface/courseList
// 接口类型参考 http://api.umucdn.cn/project/329/interface/api/4451

import { OBJ_TYPE, LIST_TYPE } from '../../enums';

export interface ICourseList {
    id?: number;
    is_assigned: 0 | 1;
    is_participate: 0 | 1;
    is_collect: 0 | 1;
    group_title: string;
    obj_id: string;
    obj_type: OBJ_TYPE;
    module_num: string;
    group_num: string;
    title: string;
    direct_category_id: string[];
    category_id: string[];
    enterprise_id: string;
    access_code?: string;
    create_ts: string;
    participate_num: string;
    session_num: string;
    head_img: string;
    share_url: string;
    shareQrc: string;
    search_refer: string;
    tag_list?: string[];
    topic_id?: string;
    _highlights?: {
        desc?: {
            _highlight: string;
        };
        session_list?: {
            session_index: number;
            session_type: number;
            _highlight: string;
        };
        creator_name?: {
            _highlight: string;
        };
    };
}

export interface ISearchTypeList {
    text: string;
    type: LIST_TYPE;
}

export interface ISearchHistoryList {
    keyword_id: string;
    keyword: string;
}
